// Shared hero-media in-memory cache. Survives route changes so revisiting a
// page shows its hero instantly (no re-fetch, no flash of blank).
import { listHeroMedia, absoluteUrl } from "@/lib/api";

// Cache key is `${page}:${device}` so mobile & desktop don't clobber each other.
const heroCache = new Map();
const inflight = new Map();

function keyFor(page, device) {
  return `${page}:${device || "all"}`;
}

export function getCachedHero(page, device) {
  return heroCache.get(keyFor(page, device));
}

export function preloadImage(url) {
  if (!url) return;
  const img = new Image();
  img.src = absoluteUrl(url);
}

export async function fetchHeroWithCache(page, device) {
  const k = keyFor(page, device);
  if (heroCache.has(k)) return heroCache.get(k);
  if (inflight.has(k)) return inflight.get(k);
  const p = listHeroMedia(true, page, device)
    .then((list) => {
      heroCache.set(k, list);
      inflight.delete(k);
      (list || []).forEach((m) => {
        if (m?.type === "image" && m?.url) preloadImage(m.url);
      });
      return list;
    })
    .catch((e) => {
      inflight.delete(k);
      throw e;
    });
  inflight.set(k, p);
  return p;
}

// Kick off prefetches for a list of page keys. Idempotent — no-ops if already cached.
export function prefetchHeroPages(pages, device) {
  pages.forEach((p) => {
    const k = keyFor(p, device);
    if (!heroCache.has(k) && !inflight.has(k)) {
      fetchHeroWithCache(p, device).catch(() => { /* ignore */ });
    }
  });
}
